import { Skeleton } from 'antd';

export const CardSkeleton = () => {
  return (
    <div className="flex flex-col gap-4 items-center justify-center text-gray-300">
      <Skeleton
        active={false}
        avatar={{ shape: 'square', size: 40 }}
        title={false}
        paragraph={{
          rows: 2,
          width: ['80%', '40%'],
          style: { marginBottom: 8 },
        }}
        className="w-full h-full"
      />
      <Skeleton
        active={false}
        paragraph={{ rows: 1, width: ['100%'] }}
        className="w-full h-full"
      />
    </div>
  );
};
